import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { translations } from "../langauge.js";
import { useNavigate, useLocation } from "react-router-dom";
import AudioPlayer from "./Audioplayer.jsx";
import ReactCountryFlag from "react-country-flag";

const Wrapper = ({ children }) => {
  const { lang, country, handleLanguageChange, handleCountryChange } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [stagedLang, setStagedLang] = useState(lang);
  const [stagedCountry, setStagedCountry] = useState(country);

  const countries = [
    { code: "international", nameKey: "country_international", flag: "🌍" },
    { code: "kw", nameKey: "country_kuwait", flag: "🇰🇼" },
    { code: "ae", nameKey: "country_uae", flag: "🇦🇪" },
    { code: "sa", nameKey: "country_saudi_arabia", flag: "🇸🇦" },
    { code: "bh", nameKey: "country_bahrain", flag: "🇧🇭" },
    { code: "qa", nameKey: "country_qatar", flag: "🇶🇦" },
    { code: "om", nameKey: "country_oman", flag: "🇴🇲" },
    { code: "jo", nameKey: "country_jordan", flag: "🇯🇴" },
    { code: "eg", nameKey: "country_egypt", flag: "🇪🇬" },
  ];

  return (
    <div className="gomenuMainWrapper">
      <div className="main-wrapper">
        {showLanguageMenu && (
          <div
            className="backdropDiv"
            onClick={() => {
              setShowLanguageMenu(false);
            }}
          ></div>
        )}
        <div className="navbar" style={{border: 'none'}}>
          {showLanguageMenu && (
          <div
            className="navbar_backdrop"
            onClick={() => {
              setShowLanguageMenu(false);
            }}
          ></div>
        )}
          <div className="logidiv">
            <h2>gomenu v3.0</h2>
          </div>
          <div className="rightnavdiv">
            <AudioPlayer src="/audio/test.mp3" />
            {/* <div className="audionDIv">
            {" "}
            <audio controls>
              <source src="/sound.mp3" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div> */}
            <div className="languageDiv">
              <span
                className="mb-0"
                onClick={() => {
                  setStagedLang(lang);
                  setStagedCountry(country);
                  setShowLanguageMenu(true);
                }}
                role="button"
                aria-label={translations[lang].choose_lagnuage}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setStagedLang(lang);
                    setStagedCountry(country);
                    setShowLanguageMenu(true);
                  }
                }}
              >
                <img src="./images/globe.png" alt="" />
              </span>
              {showLanguageMenu && (
                <div className="languageMenuDiv">
                  <div className="languageMenuHeader">
                    <div
                      className="controlBtn"
                      onClick={() => setShowLanguageMenu(false)}
                      role="button"
                      aria-label="Close"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setShowLanguageMenu(false);
                        }
                      }}
                    >
                      <img alt="Close" src="./images/cross.png" />
                    </div>
                    <p className="languageMenuTitle">{translations[lang].choose_lagnuage}</p>
                  </div>
                  
                  <div className="languageMenuContent">
                    <div className="languageSection">
                      <div className="sectionLabel">{translations[lang].language_label}</div>
                      <ul className="languageList">
                        <li
                          className={stagedLang === "en" ? "active" : ""}
                          onClick={() => {
                            setStagedLang("en");
                          }}
                        >
                          English
                        </li>
                        <li
                          className={stagedLang === "ar" ? "active" : ""}
                          onClick={() => {
                            setStagedLang("ar");
                          }}
                          
                        >
                          العربية
                        </li>
                      </ul>
                    </div>

                    <div className="sectionDivider"></div>

                    <div className="countrySection">
                      <div className="sectionLabel">{translations[lang].country_label}</div>
                      <ul className="countryList">
                        {countries.map((countryItem) => (
                          <li
                            key={countryItem.code}
                            className={stagedCountry === countryItem.code ? "active" : ""}
                            onClick={() => {
                              setStagedCountry(countryItem.code);
                            }}
                          >
                            <span className="countryFlag">
                              {countryItem.code === "international" ? (
                                countryItem.flag
                              ) : (
                                <ReactCountryFlag
                                  countryCode={countryItem.code.toUpperCase()}
                                  svg
                                  style={{
                                    width: "20px",
                                    height: "15px",
                                  }}
                                  title={translations[lang][countryItem.nameKey]}
                                />
                              )}
                            </span>
                            <span className="countryName">{translations[lang][countryItem.nameKey]}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <button 
                    type="button" 
                    className="applyBtn"
                    onClick={() => {
                      handleLanguageChange(stagedLang);
                      handleCountryChange(stagedCountry);
                      setShowLanguageMenu(false);
                    }}
                  >
                    {translations[lang].apply}
                  </button>

                </div>
              )}
            </div>
          </div>
        </div>
        {showLanguageMenu && (
          <div className="languageMenuMobileSection">
            <div className="languageMenuHeader">
              <div
                className="controlBtn"
                onClick={() => setShowLanguageMenu(false)}
                role="button"
                aria-label="Close"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setShowLanguageMenu(false);
                  }
                }}
              >
                <img alt="Close" src="./images/cross.png" />
              </div>
              <p className="languageMenuTitle">{translations[lang].choose_lagnuage}</p>
            </div>
            
            <div className="languageMenuContent">
              <div className="languageSection">
                <div className="sectionLabel" style={{fontSize: lang == 'ar' && 15}}>{translations[lang].language_label}</div>
                <ul className="languageList">
                  <li
                    className={stagedLang === "en" ? "active" : ""}
                    onClick={() => {
                      setStagedLang("en");
                    }}
                  >
                    English
                  </li>
                  <li
                    className={stagedLang === "ar" ? "active" : ""}
                    onClick={() => {
                      setStagedLang("ar");
                    }}
                    
                  >
                    العربية
                  </li>
                </ul>
              </div>

              <div className="sectionDivider"></div>

              <div className="countrySection">
                <div className="sectionLabel" style={{fontSize: lang == 'ar' && 15}}>{translations[lang].country_label}</div>
                <ul className="countryList">
                  {countries.map((countryItem) => (
                    <li
                      key={countryItem.code}
                      className={stagedCountry === countryItem.code ? "active" : ""}
                      onClick={() => {
                        setStagedCountry(countryItem.code);
                      }}
                    >
                      <span className="countryFlag">
                        {countryItem.code === "international" ? (
                          countryItem.flag
                        ) : (
                          <ReactCountryFlag
                            countryCode={countryItem.code.toUpperCase()}
                            svg
                            style={{
                              width: "20px",
                              height: "15px",
                            }}
                            title={translations[lang][countryItem.nameKey]}
                          />
                        )}
                      </span>
                      <span className="countryName">{translations[lang][countryItem.nameKey]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <button 
              type="button" 
              className="applyBtn"
              onClick={() => {
                handleLanguageChange(stagedLang);
                handleCountryChange(stagedCountry);
                setShowLanguageMenu(false);
              }}
            >
              {translations[lang].apply}
            </button>
          </div>
        )}
        {location.pathname !== "/" && (
          <div
            className="gobackdiv"
            style={{ padding: lang === "ar" && "14px 15px" }}
          >
            <p
              className="gobackbtn"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer", display: "flex", alignItems: "center", marginBottom: 0 }}
            >
              <img
                alt="go back"
                src="./images/left-arrow.png"
                style={{
                  marginRight: lang === "en" ? "15px" : 0,
                  marginLeft: lang === "ar" ? "15px" : 0,
                  height: "20px",
                  width: "auto",
                  transform: lang === "ar" ? "rotate(180deg)" : undefined,
                }}
              />
              {translations[lang].go_back}
            </p>
          </div>
        )}

        {children}
      </div>
    </div>
  );
};

export default Wrapper;
